export default "__VITE_ASSET__H8yhhftB__"